import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CinematicFeature from "./sections/CinematicFeature";
import TheRitualFlow from "./sections/TheRitualFlow";
import ThePulse from "./sections/ThePulse";
import NewArrivalsGallery from "./sections/NewArrivalsGallery";
import VoicesOfThePool from "./sections/VoicesOfThePool";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CinematicFeature />
      <TheRitualFlow />
      <ThePulse />
      <NewArrivalsGallery />
      <VoicesOfThePool />
      <Footer />
    </div>;
}